import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { WyswigModule } from '@shared/libraries/wyswig/wyswig.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
import localePlExtra from '@angular/common/locales/extra/pl';
import { AppModalModule } from '@shared/modules/modal/modal.module';
import { DateModule } from '@shared/modules/form/modules/date/date.module';
import { AppTreeModule } from '@shared/modules/tree/tree.module';

registerLocaleData(localePl, localePlExtra);

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ReactiveFormsModule,
        AppRoutingModule,
        CoreModule,
        AppModalModule,
        AppTreeModule,
        DateModule,
        WyswigModule,
    ],
    providers: [
        {
            provide: LOCALE_ID,
            useValue: 'pl-PL',
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
